<template>
  <v-card class="rounded-xl" elevation="0" outlined width="100%">
    <v-card-text>
      <Pie :data="data" :options="options"></Pie>
    </v-card-text>
  </v-card>
</template>
<script>
import { Pie } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);
export default {
  name: "PieCard",
  mounted: function () {},
  components: { Pie },
  computed: {},
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          labels: ["VueJs", "EmberJs", "ReactJs", "AngularJs"],
          datasets: [
            {
              label: "My First Dataset",
              backgroundColor: ["#41B883", "#E46651", "#00D8FF", "#DD1B16"],
              data: [40, 20, 80, 10],
            },
          ],
        };
      },
    },

    options: {
      type: Object,
      default: () => {
        return { responsive: true, maintainAspectRatio: false };
      },
    },
  },
  data() {
    return {
      chartData: {},
    };
  },
};
</script>
